/** Train configuration and car layout along the track. */
export interface TrainConfig {
  cars: number;
  carMass: number; // kg, loaded
  carLength: number; // m, coupler to coupler
  seatsPerCar: number;
}

export const DEFAULT_TRAIN: TrainConfig = { cars: 5, carMass: 900, carLength: 3.2, seatsPerCar: 4 };

export function trainLength(t: TrainConfig): number {
  return t.cars * t.carLength;
}

export function totalMass(t: TrainConfig): number {
  return t.cars * t.carMass;
}

/** Arc-length offset of car i's centre behind the train head (s of the front coupler). */
export function carOffset(t: TrainConfig, i: number): number {
  return -(i + 0.5) * t.carLength;
}

/** Bogie offsets from the car centre (front, rear). Cars sit on two bogies. */
export function bogieOffsets(t: TrainConfig): [number, number] {
  const half = t.carLength * 0.35;
  return [half, -half];
}
